import { BodyText, Button, Heading, Modal } from '@farol-ds/react'
import { Image } from '@jusbrasil-web/shared-next-image'
import { useEffect } from 'react'

import { useValidateOabModalContext } from '../../context'
import validatedSvg from '../../images/oab-verificada.svg'
import styles from '../steps.module.scss'

export function ValidatingSuccess() {
  const { setOpenToFalse, setReloadOnModalClose } = useValidateOabModalContext()

  useEffect(() => {
    setReloadOnModalClose(true)
  }, [setReloadOnModalClose])

  return (
    <>
      <Modal.IconClose />
      <Modal.Body className={styles.infoModalBody}>
        <Image src={validatedSvg} width={140} height={140} loading="lazy" alt="" />
        <Heading className={styles['infoModalBody-heading']}>OAB verificada</Heading>
        <BodyText className={styles['infoModalBody-bodyText']}>
          Agora você já pode acessar a peça processual.
        </BodyText>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={setOpenToFalse} kind="primary">
          Concluir
        </Button>
      </Modal.Footer>
    </>
  )
}
